export const READER_TOOFI_VISIBILITY_EVENT = "athr:reader-toofi-visibility";

export const dispatchReaderToofiVisibility = (open: boolean) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(READER_TOOFI_VISIBILITY_EVENT, { detail: { open } }));
};
